export enum TaskListCode {
  Received = 'received',
  Ongoing = 'ongoing',
  Archived = 'archived',
  Answered = 'answered',
}
